module.exports = __webpack_public_path__ + "media/write.861b3d7b.mp3";